import type {
  IClinicianAcuityCatalogResponse,
  IClinicianAssessment,
  IClinicianAssessmentUpsert,
} from "../../../core/ports/driver/VisitNotesService";

interface IClinicianAcuityRoutes {
  apiGetClinicianAcuityCatalog: string;
  apiPutClinicianAssessment: string;
}

export function createVisitNotesClinicianAcuityApi({
  GET,
  PUT,
  getAuthenticationToken,
  routes,
}: {
  GET: IAPIProvider["GET"];
  PUT: IAPIProvider["PUT"];
  getAuthenticationToken: IAuthService["getAuthenticationToken"];
  routes: IClinicianAcuityRoutes;
}) {
  const getClinicianAcuityCatalogAPI =
    async (): Promise<IClinicianAcuityCatalogResponse> => {
      const response = await GET(
        routes.apiGetClinicianAcuityCatalog,
        {},
        { Authorization: `Bearer ${await getAuthenticationToken()}` }
      );
      return response.data || response;
    };

  const putClinicianAssessmentAPI = async (
    clinicId: number,
    patientId: number,
    noteId: number,
    request: IClinicianAssessmentUpsert
  ): Promise<IClinicianAssessment> => {
    const url = routes.apiPutClinicianAssessment
      .replace("{clinic_id}", clinicId.toString())
      .replace("{patient_id}", patientId.toString())
      .replace("{note_id}", noteId.toString());
    const response = await PUT(url, request, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });
    return response.data || response;
  };

  return {
    getClinicianAcuityCatalogAPI,
    putClinicianAssessmentAPI,
  };
}
